module.exports = __webpack_public_path__ + "img/prize.49df9f6d.png";